var map = {
	"./HZGB01-01.png": "K+P5",
	"./HZGB01-02.png": "DgW2",
	"./HZGB01-03-03.png": "M/t9",
	"./HZGB01-03-04.png": "m7Si",
	"./HZGB02-01-04.png": "NDg+",
	"./HZGB02-02-04.png": "EF1f",
	"./HZGB02-02-06.png": "1Zb+",
	"./HZGB02-02-08.png": "YPho",
	"./HZGB02-03-02.png": "Bt70",
	"./HZGB03-01-02.png": "9viw",
	"./HZGB03-01-02_1.png": "2A36",
	"./HZGB03-01-02_2.png": "x+i7",
	"./HZGB03-01-02_3.png": "N0iX",
	"./HZGB03-02.png": "fLmX",
	"./HZGB03-03.jpg": "dBQx",
	"./HZGB06-15W.png": "5WxW",
	"./HZGB06-30W.png": "iK8h",
	"./HZGB06-60W.png": "EGl8",
	"./HZGB10-01.png": "yTjB",
	"./HZGB12-10w.png": "vbJZ",
	"./HZGB12-20w.png": "JFU4",
	"./HZGB12-5w.png": "ZtLP",
	"./HZGB12-9w.png": "sCFa",
	"./crlogo.png": "t4eD",
	"./interface.png": "1SeG",
	"./kong.jpg": "3qUL",
	"./lunbo101.png": "yTEY",
	"./lunbo102.png": "o5KC",
	"./lunbo111.png": "SFGz",
	"./lunbo121.png": "WtFF",
	"./lunbo122.png": "wU35",
	"./lunbo123.png": "p7df",
	"./lunbo131.png": "nXVb",
	"./lunbo132.png": "KKBj",
	"./lunbo133.png": "oOoC",
	"./lunbo151.png": "QmcI",
	"./lunbo152.png": "HMaz",
	"./lunbo153.png": "Sj6e",
	"./lunbo154.png": "T2y9",
	"./lunbo201.png": "ok6H",
	"./lunbo202.png": "RYiS",
	"./lunbo21.jpg": "/pNm",
	"./lunbo22.jpg": "NgrS",
	"./lunbo221.png": "/VOh",
	"./lunbo222.png": "sYc3",
	"./lunbo223.png": "hbDc",
	"./lunbo23.jpg": "VP4M",
	"./lunbo231.jpg": "NaLm",
	"./lunbo24.jpg": "K2ee",
	"./lunbo241.png": "YXId",
	"./lunbo242.png": "QKok",
	"./lunbo243.png": "YxcV",
	"./lunbo41.png": "lLXW",
	"./lunbo42.png": "5QB/",
	"./lunbo43.png": "IDYk",
	"./lunbo51.png": "W+HG",
	"./lunbo52.png": "AjL+",
	"./lunbo53.png": "zaC9",
	"./lunbo61.png": "/iLc",
	"./lunbo62.png": "DtW5",
	"./lunbo63.png": "383N",
	"./microphone.png": "B8Bj",
	"./overview1.jpg": "SXE5",
	"./overview10.jpg": "hsfZ",
	"./overview11.jpg": "WyTi",
	"./overview12.jpg": "ym2B",
	"./overview13.jpg": "BXGw",
	"./overview14.jpg": "TXnX",
	"./overview15.jpg": "kPUQ",
	"./overview19.jpg": "5D09",
	"./overview2.jpg": "qxx3",
	"./overview20.jpg": "SwuR",
	"./overview21.jpg": "NCrn",
	"./overview22.jpg": "wevt",
	"./overview23.jpg": "ul6Y",
	"./overview27.jpg": "PTTL",
	"./overview3.jpg": "zE6M",
	"./overview30.jpg": "Aher",
	"./overview4.jpg": "3VDV",
	"./overview5.jpg": "weCn",
	"./overview6.jpg": "AEVU",
	"./overview7.jpg": "15X6",
	"./overview8.jpg": "p30j",
	"./overview9.jpg": "pGNL",
	"./parameter1.jpg": "9Dyk",
	"./parameter10.jpg": "qIMe",
	"./parameter11.jpg": "WsN9",
	"./parameter12.jpg": "J3jd",
	"./parameter13.jpg": "G9z1",
	"./parameter14.jpg": "A/O0",
	"./parameter15.jpg": "SzCq",
	"./parameter16.jpg": "8ok0",
	"./parameter17.jpg": "htqM",
	"./parameter2.jpg": "HwMG",
	"./parameter3.jpg": "aAhs",
	"./parameter4.jpg": "L0zX",
	"./parameter5.jpg": "22mk",
	"./parameter6.jpg": "tWEp",
	"./parameter7.jpg": "BuPv",
	"./parameter8.jpg": "TGbe",
	"./parameter9.jpg": "J3yB",
	"./powerAmplifier150w.png": "xDTu",
	"./powerAmplifier200w.png": "lK09",
	"./powerAmplifier240w.png": "pguN",
	"./powerAmplifier500w.png": "RbhY",
	"./railwayBroadcast1.0.png": "6wx9",
	"./railwayBroadcast2.0.png": "Cait",
	"./speaker.png": "U6cE",
	"./stockvault.jpg": "NTfb",
	"./taobao.png": "3/Hl",
	"./wuxian_v1.0.png": "YDJe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kbg/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img ^\.\/.*$
// module id = kbg/
// module chunks = 0